<div class="nextpage">
    <np-header sitename="Data Quality Remediation and Management"></np-header>
    <np-nav [navItems]="navigationItems"></np-nav>
</div>

<div class="mx-3">
    <router-outlet />
</div>

<div class="nextpage">
    <np-footer></np-footer>
</div>
